module.exports = __webpack_public_path__ + "img/severe.94784bbd.jpg";